import React, {useCallback} from "react";
import {useEventListener} from "../../../infrastructure/hooks/useEventListener";
import {KEY_CODES} from "../../../core/consts";
import {NEW_SEARCH_WIDGET} from "../new-search-widget.consts";
import {RouterController} from "../../../core/components/router/router-controller";
import {RouteModel} from "../../../core/components/router/models/route-model";

export const NewSearchWidgetEntityKeyboardClickComposer = (Widget) => (({
                                                                          controller,
                                                                          entity,
                                                                          listModel,
                                                                          isHighlighted,
                                                                          isRecentSearchesList,
                                                                          onMouseEnter,
                                                                          index
                                                                        }) => {
  const {device: {isSmallView}} = controller;

  const onKeyboardClick = useCallback((event) => {
    if (!isSmallView) {

      const {keyCode} = event;
      const highlightedElement = document.querySelector('.highlighted_item');

      if (isHighlighted && keyCode === KEY_CODES.enter) {
        const routerController: RouterController = controller.props.ioc.getInstance(RouterController)
        const routeModel: RouteModel = routerController.findRouteByName(entity.linkModel.name);
        const url: String = `${controller.navigationManager.createUrl(routeModel.path, entity.linkModel)}`

        controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onTabClick, {reset: true});
        controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.entityClickHandler, {
          item: entity,
          subSource: listModel?.id
        })
        controller.navigationManager.gotoUrl(url, false)
      }

      if (keyCode === KEY_CODES.down) {
        if (highlightedElement && Array.from(highlightedElement.children).length === 0) {
          highlightedElement.scrollIntoView({behavior: "auto", block: "end"});
        }
      }

      if (keyCode === KEY_CODES.up) {
        if (highlightedElement && Array.from(highlightedElement.children).length === 0) {
          highlightedElement.scrollIntoView({behavior: "auto", block: "start"});
        }
      }
    }
  });

  useEventListener('keydown', onKeyboardClick);

  const newProps = {
    controller,
    entity,
    isRecentSearchesList,
    listModel,
    isHighlighted,
    onMouseEnter,
    index
  };

  return <Widget {...newProps}/>;
});
